import { getAssetUrl } from '@/utils/contentFullAsset';
import './cardImageLogo.scss';

const CardImageLogo = ({ content }: any) => {
  return (
    <div data-testid="card-container" className="a-cardImageLogo__container">
      {content.map((item: any, index: number) => (
        <div
          key={index}
          data-testid="card-element"
          className="a-cardImageLogo__container__elements"
        >
          <div className="a-cardImageLogo__container__elements__img">
            {item.imagen.map((element, idx) => {
              return <img src={getAssetUrl(element)} alt={`Imagen ${idx + 1}`} key={idx} />;
            })}
          </div>
          <h3 data-testid="card-title" className="a-cardImageLogo__container__elements__title">
            {item.nombre}
          </h3>
          {item.subtitulo && (
            <p className="a-cardImageLogo__container__elements__subtitle">{item.subtitulo}</p>
          )}
        </div>
      ))}
      <div data-testid="divider-line" className="a-cardImageLogo__container__line" />
    </div>
  );
};

export default CardImageLogo;
